// "Check my coverage" route + analytics control names.
export const COVERAGE_CHECK_URL = '/coverage-check';

// Benefits screen route. PHI safety: providerTypes come from the store/270 response, never the URL.
export const COVERAGE_BENEFITS_URL = '/coverage-benefits';

// Not-eligible screen for the coverage-check flow (unauthenticated). Uses the guest eligibility
// endpoint; no RegisterBreadcrumb / no withAuthSync. The standard /eligibility-error requires auth.
export const COVERAGE_ELIGIBILITY_ERROR_URL = '/coverage-eligibility-error';

// Adobe data-layer control names (analytics carry no PHI, outcome metadata only).
export const COVERAGE_CHECK_SUBMIT_ATTEMPT =
  'check-my-coverage-see-estimated-cost-attempt';
export const COVERAGE_CHECK_SUBMIT_SUCCESS =
  'check-my-coverage-see-estimated-cost-success';
export const COVERAGE_CHECK_SKIP = 'check-my-coverage-skip-coverage-check';
export const COVERAGE_CHECK_EXIT =
  'finding-coverage-details-exit-coverage-check';

// Client-side validation-failure error code/type for the attempt errorInfo.
export const COVERAGE_CHECK_VALIDATION_ERROR_CODE = 'REQUIRED_FIELD';
export const COVERAGE_CHECK_VALIDATION_ERROR_TYPE = 'Validation';

// errorLocation for the Internal_API failure event.
export const COVERAGE_CHECK_ERROR_LOCATION = 'CoverageCheck';

// 270/271 outcome analytics (PHI-free: type + coarse result only, never identity).
export const ELIGIBILITY_CHECK_TYPE_KEY = 'eligibility_check_type';
export const ELIGIBILITY_CHECK_RESULT_KEY = 'eligibility_check_result';
export const ELIGIBILITY_CHECK_TYPE_270_271 = '270_271';
export const ELIGIBILITY_CHECK_TYPE_CSV = 'csv';
export const ELIGIBILITY_CSV_ERROR_LOCATION = 'CoverageCheck-CSV';
export const ELIGIBILITY_RESULT_ELIGIBLE = 'eligible';
export const ELIGIBILITY_RESULT_NO_DATA = 'no_data';
export const ELIGIBILITY_RESULT_FAILED = 'failed';
export const ELIGIBILITY_270_271_ERROR_LOCATION = 'Registration-270-271';

// Benefits screen control names (no PHI).
export const COVERAGE_BENEFITS_CONTINUE =
  'your-benefits-for-mdlive-visits-continue-to-book-a-visit';
// Tile-select control name; left unwired (tile-select stays nav-only).
export const COVERAGE_BENEFITS_SELECT_TILE = 'coverage-benefits-select-tile';

// Almost-there CTA control names (no PHI). Skip is distinct from the form Skip
// (COVERAGE_CHECK_SKIP) so the two report separately.
export const COVERAGE_ALMOST_THERE_CONTINUE =
  'coverage-almost-there-continue-to-check-coverage';
export const COVERAGE_ALMOST_THERE_SKIP =
  'coverage-almost-there-skip-coverage-check';
